import { ENUM_KITCHEN_ROLE } from '@cokitchen/cokitchen-auth';
import { RolePermissionType } from '../helpers/types';
import { initRolePermissions } from '../helpers/constants';

export const permissionControls: Record<ENUM_KITCHEN_ROLE, RolePermissionType> = {
  [ENUM_KITCHEN_ROLE.KITCHEN_ADMIN]: {
    ...initRolePermissions,
    isSettingsRole: true,
    isAdminRole: true,
    canFinishOrder: true,
    hideOrderCardActionButton: true,
    showOrderLocation: true,

    showHeaderBrands: true,
    isSplitScreenRole: true,
    isKitchenAdminRole: true,
    canPrintReceipt: true,
    hasAllItemTypes: true,
    showActiveBrands: true,
    isAKitchenStaff: true,
    canViewRiderNote: true,
    canViewPackagingSplitScreenName: true,
    canViewAddressDetails: true
  },
  SHIFT_SUPERVISOR: {
    ...initRolePermissions,
    isSettingsRole: true,
    isAdminRole: true,
    canFinishOrder: true,
    hideOrderCardActionButton: true,
    showOrderLocation: true,

    showHeaderBrands: true,
    isSplitScreenRole: true,
    isKitchenAdminRole: true,
    canPrintReceipt: true,
    hasAllItemTypes: true,
    showActiveBrands: true,
    isAKitchenStaff: true,
    canViewRiderNote: true,
    canViewPackagingSplitScreenName: true,
    canViewAddressDetails: true
  },
  [ENUM_KITCHEN_ROLE.PACKAGING]: {
    ...initRolePermissions,
    showCardHeaderTag: true,
    isPackagingRole: true,
    showCheckbox: true,
    canViewScheduledTime: true,
    canPrintReceipt: true,
    canRoleClockIn: true,
    showBrandReadyHeaderTag: true,
    showPackagingLiveOrders: true,
    showDocketButton: true,
    showPackagingSplitScreens: true,
    canViewPackagingSplitScreenName: true
  },
  [ENUM_KITCHEN_ROLE.KITCHEN_STAFF]: {
    ...initRolePermissions,
    showCardHeaderTag: true,
    showActiveBrands: true,
    isKitchenRole: true,
    itemType: 'FOOD',
    showHeaderBrands: true,
    canViewScheduledTime: true,
    canPrintSticker: true,
    isAKitchenStaff: true,
    showDeliveryStatus: true,
    showIfOrderIsReady: true,
    canViewPackagingSplitScreenName: true
  },
  [ENUM_KITCHEN_ROLE.SUPER_ADMIN]: {
    ...initRolePermissions,
    isSplitScreenRole: true,
    isSettingsRole: true,
    isSuperAdminRole: true,
    isAdminRole: true,
    canFinishOrder: true,

    hideOrderCardActionButton: true,
    showOrderLocation: true,

    showPrintReceipt: true,
    canPrintReceipt: true,
    hasAllItemTypes: true,
    canRoleClockIn: true,
    canViewRiderNote: true,
    canViewPackagingSplitScreenName: true,
    canViewAddressDetails: true
  },
  [ENUM_KITCHEN_ROLE.FRONT_DESK]: {
    ...initRolePermissions,
    isFrontdeskRole: true,
    showOrderLocation: true,
    canManageSurge: false,
    hasAllItemTypes: true,
    canViewRiderNote: true,
    canViewPackagingSplitScreenName: true,
    canViewAddressDetails: true
  },
  [ENUM_KITCHEN_ROLE.SHOP_STAFF]: {
    ...initRolePermissions,
    itemType: 'SHOP',
    showPrintReceipt: true,
    isShopRole: true,
    showCheckbox: true,
    canPrintReceipt: true,
    showActiveBrands: true,
    showDeliveryStatus: true
  },
  [ENUM_KITCHEN_ROLE.ADMIN]: {
    ...initRolePermissions,
    hasAdmin: true,
    isAdminRole: true,
    hideOrderCardActionButton: true,
    canFinishOrder: true,

    canPrintReceipt: true,
    itemType: 'FOOD'
  },
  [ENUM_KITCHEN_ROLE.DEVELOPER]: {
    ...initRolePermissions,
    isSettingsRole: true,
    isSplitScreenRole: true,
    isAdminRole: true,
    canFinishOrder: true,

    hideOrderCardActionButton: true,

    isDeveloperRole: true,
    isSuperAdminRole: true,
    hasAllItemTypes: true,
    canViewRiderNote: true,
    canViewPackagingSplitScreenName: true
  },
  [ENUM_KITCHEN_ROLE.FCB_KITCHEN_SUPERVISOR]: {
    ...initRolePermissions,
    hasSupervisor: true
  },
  [ENUM_KITCHEN_ROLE.FCB_PACKAGING_STAFF]: {
    ...initRolePermissions,
    isFcbRole: true,
    itemType: 'FOOD'
  },
  [ENUM_KITCHEN_ROLE.FCB_KITCHEN_STAFF]: {
    ...initRolePermissions,
    showHeaderBrands: true,
    isFcbRole: true,
    itemType: 'FOOD'
  },
  [ENUM_KITCHEN_ROLE.LIQUOR_KITCHEN_ADMIN]: {
    ...initRolePermissions,
    showActiveBrands: true,
    isLiquorAdminRole: true,
    hasAllItemTypes: true,
    showDeliveryStatus: true,
    showOrderLocation: true,
    showTestMode: false,
    canViewRiderNote: true,
    canViewAddressDetails: true
  }
};
